import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@environments/environment';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LocalRepository } from '@shared/helper/local-repository';
import { Observable } from 'rxjs';
import { AlertConfigModel } from '@shared/components/confirm-alert/confirm-alert.component';
import { Injectable } from '@angular/core';
import { AuthContainerDialogComponent } from '@app/auth/auth-container-dialog/auth-container-dialog.component';
import { ComponentType } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})
export class Util {

  imageUrl: string = environment.ImageUrl;


  // ? Access To Android
  public readonly getAndroid = false;
  // ? Image Getter -- 1 for book image -- 2 for user avatar
  public getImages(objectTypeId?: number, objectId?: string, extention = '.jpg') {
    switch (objectTypeId) {

      // ? User Avatar
      case 1:
        return (`${this.imageUrl}/avatars/` + objectId + extention);

      // ? Book Image
      case 2:
        return (`${this.imageUrl}/books/` + objectId + extention);

      // ? Publisher Avatar
      case 3:
        return (`${this.imageUrl}/publishers/` + objectId + extention);

      // ? Author Avatar
      case 4:
        return (`${this.imageUrl}/authors/` + objectId + extention);

      // ? Publisher Banner
      case 5:
        return (`${this.imageUrl}/publisherwallpapers/` + objectId + extention);

      // ? User Wallpaper
      case 6:
        return (`${this.imageUrl}/wallpapers/` + objectId + extention);

      // ? Author Wallpaper
      case 7:
        return (`${this.imageUrl}/authorwallpapers/` + objectId + extention);

      // ? post image
      case 8:
        return (`${this.imageUrl}/posts/` + objectId + extention);

      // ? Genres List image
      case 9:
        return (`${this.imageUrl}/genres/` + objectId + extention);
      // ? Temp Books image
      case 10:
        return (`${this.imageUrl}/tempbooks/` + objectId + extention);
      default:
        return '';
    }
  }



  public opensigninDialog(dialog: MatDialog, currentUrl: string, localRep: LocalRepository) {

    if (localRep.IsInBrowser) {
      if (currentUrl) {
        localRep.setLocalItem('previousUrl', currentUrl);
      }

      dialog.open(AuthContainerDialogComponent, {
        panelClass: 'auth-dialog',
        data: {
          redirectPath: currentUrl
        },
        disableClose: true
      }).afterClosed().subscribe();
    }

  }

  public opensigninAlertBottomSheet(dialog: MatDialog, currentUrl: string, localRep: LocalRepository) {
    if (localRep.IsInBrowser) {
      // ? Set Current Url Address for backdrop
      if (currentUrl) {
        localRep.setLocalItem('previousUrl', currentUrl);
      }
      // ? Show bottomsheet Alert
      dialog.open(AuthContainerDialogComponent, {
        panelClass: 'auth-dialog',
        data: {
          redirectPath: currentUrl
        },
        disableClose: true
      }).afterClosed().subscribe();


    }
  }

  // ? Replace Farsi Numbers With English
  public replaceFaNumbers(text: string) {

    const
      persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
      arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g],
      fixNumbers = function (str: string) {
        if (typeof str === 'string') {
          for (let i = 0; i < 10; i++) {
            str = str.replace(persianNumbers[i], i.toString()).replace(arabicNumbers[i], i.toString());
          }
        }
        return str;
      };

    return fixNumbers(text);
  }

  // ? Limit Texts to special Lines
  public LimitText(elementId: string, limitedClassName: string, localRepository: LocalRepository) {
    const element = localRepository.getDocument.getElementById(elementId);
    const flodElement = localRepository.getDocument.getElementById(elementId + 'flode');
    const unFlodElement = localRepository.getDocument.getElementById(elementId + 'unflode');

    if (element && element.classList.contains(limitedClassName)) {
      element?.classList.remove(limitedClassName);
      flodElement?.classList.add('hidden');
      flodElement?.classList.remove('block');
      unFlodElement?.classList.add('block');
      unFlodElement?.classList.remove('hidden');
    }
    else {
      element?.classList.add(limitedClassName);
      flodElement?.classList.add('block');
      flodElement?.classList.remove('hidden');
      unFlodElement?.classList.add('hidden');
      unFlodElement?.classList.remove('block');
    }
  }

  public copyInviteCode(url: string, isLogin = false, inviteCode = '', _localRepository: LocalRepository) {
    let query: string;
    if (url.includes('?')) {
      query = "&inviteCode=" + inviteCode;
    } else {
      query = "?inviteCode=" + inviteCode;
    }
    if (_localRepository.IsInBrowser) {
      if (isLogin) {
        navigator?.clipboard?.writeText(url + query);
      } else {
        navigator?.clipboard?.writeText(url);
      }
    }
  }


  public peopleLiked<T>(objectId: string, bottomSheet: MatBottomSheet, dialog: MatDialog, localRepository: LocalRepository, component: ComponentType<T>, isReacted = false) {
    if (localRepository.IsInMobile) {
      bottomSheet.open(component, {
        panelClass: 'basic-bottomsheet',
        data: {
          objectId,
          isReacted,
        }
      });
    }
    else {
      dialog.open(component, {
        panelClass: 'basic-dialog',
        data: {
          objectId,
          isReacted,
        }
      });
    }
  }

  public ConfirmAlert<T>(component: ComponentType<T>, bottomSheet: MatBottomSheet, dialog: MatDialog, alertConfig: AlertConfigModel, localRepository: LocalRepository): Observable<boolean> {
    if (localRepository.IsInMobile) {
      const Alert = bottomSheet.open(component, {
        panelClass: 'Confirm-Alert-bottomsheet',
        data: alertConfig
      });

      return Alert.afterDismissed()
        .pipe(
          map(res => {
            return res === 'confirm' ? true : false;
          })
        )
    }
    else {
      const Alert = dialog.open(component, {
        panelClass: 'basic-dialog',
        data: alertConfig
      });
      return Alert.afterClosed()
        .pipe(
          map(res => {
            return res === 'confirm' ? true : false;
          })
        )
    }
  }

  public AspectRationToString(ration: number): string {
    let result: string;
    switch (ration) {
      case 1 / 1:
        result = '1:1'
        break;
      case 2 / 1:
        result = '2:1'
        break;
      case 4 / 5:
        result = '4:5'
        break;
      case 5 / 6:
        result = '5:6'
        break;

      default:
        result = '2:1'
        break;
    }
    return result;
  }

}
